<template>
  <div
    id="import-newsletter-type-subscribers"
  >
    <h2>Import Newsletter Type Subscribers</h2>

    <newsletter-type-nav :newsletterTypeId="newsletterTypeId" />

    <form
      :action="actionUrl"
      method="post"
      v-on:submit.prevent="submit"
    >
      <div
        class="form-group"
      >
        <div
          class="custom-file"
          >
          <label
            for="subscribers"
            class="custom-file-label"
          >
            Subscribers CSV (must have an 'email' header)
          </label>

          <input
            type="file"
            name="newsletter_type[import_subscribers]"
            class="custom-file-input"
            id="subscribers"
          />
        </div>
      </div>

      <div
       class="form-group text-right"
      >
        <div
          class="form-check form-check-inline"
        >
          <input
            type="checkbox"
            name="newsletter_type[reset_subscribers]"
            class="form-check-input"
            id="reset_subscribers"
          />

          <label
            class="form-check-label"
            for="reset_subscribers"
          >
            Remove prior subscribers?
          </label>
        </div>
      </div>

      <button
        class="btn btn-primary btn-block"
      >
        Upload
        <spinner size="small" v-if="loading"></spinner>
      </button>
    </form>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner'

import NewsletterTypeNav from '@/components/NewsletterTypeNav'

import FlashStore from '@/stores/FlashStore'

export default {
  data () {
    return {
      loading: false
    }
  },

  components: {
    'newsletter-type-nav': NewsletterTypeNav,
    'spinner': Spinner
  },

  computed: {
    actionUrl () {
      return this.apiUrl('/newsletter_types/' + this.newsletterTypeId + '/import_subscribers', true)
    }
  },

  props: {
    newsletterTypeId: {
      type: String,
      default: undefined
    }
  },

  methods: {
    submit (ev) {
      this.loading = true

      this.bindSubmit(ev).then((response) => {
        this.loading = false

        FlashStore.result(
          response.body.subscriber_count + ' Subscribers imported.'
        )
      }, (resp) => {
        this.loading = false
        this.$parent.processErrors(resp)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ImportNewsletterTypeSubscribers.vue